const postcodeScriptId = "daum-postcode-script";
const postcodeScriptUrl = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

export type PostcodeResult = {
  address: string;
  roadAddress: string;
  jibunAddress: string;
  zonecode: string;
  buildingName: string;
};

type DaumPostcodeData = {
  address?: string;
  roadAddress?: string;
  jibunAddress?: string;
  zonecode?: string;
  buildingName?: string;
};

type DaumPostcodeOptions = {
  oncomplete: (data: DaumPostcodeData) => void;
  onresize?: (size: { height: number; width: number }) => void;
};

export type DaumPostcode = {
  embed: (element: HTMLElement, options?: { autoClose?: boolean }) => void;
};

declare global {
  interface Window {
    daum?: {
      Postcode: new (options: DaumPostcodeOptions) => DaumPostcode;
    };
  }
}

export function normalizePostcodeResult(data: DaumPostcodeData): PostcodeResult {
  const roadAddress = data.roadAddress?.trim() || "";
  const jibunAddress = data.jibunAddress?.trim() || "";
  return {
    address: roadAddress || data.address?.trim() || jibunAddress,
    roadAddress,
    jibunAddress,
    zonecode: data.zonecode?.trim() || "",
    buildingName: data.buildingName?.trim() || "",
  };
}

export function loadPostcode(): Promise<NonNullable<Window["daum"]>> {
  if (window.daum?.Postcode) return Promise.resolve(window.daum);

  return new Promise((resolve, reject) => {
    let existing = document.getElementById(postcodeScriptId) as HTMLScriptElement | null;
    if (existing?.dataset.status === "error" || existing?.dataset.status === "loaded") {
      existing.remove();
      existing = null;
    }
    const script = existing || document.createElement("script");
    let settled = false;

    const cleanup = () => {
      script.removeEventListener("load", handleLoad);
      script.removeEventListener("error", handleError);
      window.clearTimeout(timeoutId);
    };
    const fail = (message: string) => {
      if (settled) return;
      settled = true;
      script.dataset.status = "error";
      script.remove();
      cleanup();
      reject(new Error(message));
    };

    const handleLoad = () => {
      if (settled) return;
      script.dataset.status = "loaded";
      if (!window.daum?.Postcode) {
        fail("주소검색 서비스를 불러오지 못했습니다.");
        return;
      }
      settled = true;
      cleanup();
      resolve(window.daum);
    };
    const handleError = () => fail("주소검색 서비스에 연결할 수 없습니다.");
    const timeoutId = window.setTimeout(() => fail("주소검색 서비스 응답이 지연되고 있습니다."), 12_000);

    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });

    if (!existing) {
      script.id = postcodeScriptId;
      script.src = postcodeScriptUrl;
      script.async = true;
      script.dataset.status = "loading";
      document.head.appendChild(script);
    }
  });
}
